import { Card } from 'react-bootstrap'
import styles from './Insights.module.css'

const Insights = ({ insights }) => {
  function severityTone(severity) {
    if (severity === 'High') return styles.severityHigh
    if (severity === 'Moderate') return styles.severityModerate
    return styles.severityLow // Low/mild
  }

  function severityToneInverse(severity) {
    if (severity === 'High') return styles.severityHighInverse
    if (severity === 'Moderate') return styles.severityModerateInverse
    return styles.severityLowInverse // Low/mild
  }

  function labelize(key) {
    return key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
  }

  return (
    <div className={styles.container}>
      {insights.map((item, idx) => {
        return (
          <Card key={idx} className={`${styles.card}`}>
            <div className={styles.header}>
              <div className={styles.headerRow}>
                <div>
                  <h4 className={styles.title}>{item.category}</h4>
                </div>
                <div
                  className={`${styles.severityContainer} ${severityTone(
                    item.severity
                  )}`}
                >
                  <div
                    className={`${styles.severityBadge} ${severityToneInverse(
                      item.severity
                    )}`}
                  >
                    {item.severity}
                  </div>
                  {item.composite_score}
                </div>
              </div>
            </div>
            <Card.Body className={`${styles.body} ${styles.bodySpacing}`}>
              {item.dominant_type && (
                <p className={styles.textSm}>
                  <span className={styles.textBold}>Dominant Type:</span>{' '}
                  {item.dominant_type}
                </p>
              )}
              {item.interpretation && (
                <p className={styles.textSm}>
                  <span className={styles.textBold}>Interpretation:</span>{' '}
                  {item.interpretation}
                </p>
              )}
              {item.suggested_intervention && (
                <p className={styles.textSm}>
                  <span className={styles.textBold}>
                    Suggested Intervention:
                  </span>{' '}
                  {item.suggested_intervention}
                </p>
              )}

              {item.metrics && Object.keys(item.metrics).length > 0 && (
                <div className={styles.metricsContainer}>
                  <p className={`${styles.textBold} ${styles.textSm}`}>
                    Metrics
                  </p>
                  <ul className={`${styles.metricsList} ${styles.textSm}`}>
                    {Object.entries(item.metrics).map(([key, val]) => (
                      <li key={key} className={styles.metricItem}>
                        <span className={styles.metricLabel}>
                          {labelize(key)}:
                        </span>
                        <div className={`${styles.metricValue}`}>{val}</div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </Card.Body>
          </Card>
        )
      })}
    </div>
  )
}

export default Insights
